import { memo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Loader } from 'rsuite';
import { RootState } from '../../../../../@types/RootState';
import { ButtonPrimary } from '../../../../../components';
import { useEditedPriceManagerStore } from '../../../../../store/priceManagerStore';
import { usePriceApplicationPermission } from '../../hooks/usePriceApplicationPermission';
import { ButtonDropdown } from '../ButtonDropdown';
import { EffectiveDateModal } from '../EffectiveDateModal';
import { ApplyPermissionTooltip } from './ApplyPermissionTooltip';
import useAppyPricesButton from './useAppyPricesButton';

const CTA_BUTTON_ID = 'apply-prices-btn';

const AppyPricesButton = () => {
  const { isDisabled, isDisabledOption, placeholder, handleApplyPrices, isLoading, isEffectiveDateEnabled, selectedCount } = useAppyPricesButton();
  // null = modal fechado; senão guarda se a aplicação pendente é na família.
  const [pendingApplyToFamily, setPendingApplyToFamily] = useState<boolean | null>(null);
  const { isPendingEditedPrice } = useEditedPriceManagerStore();
  const { isAllowed, isChecking } = usePriceApplicationPermission();
  const displayType = useSelector((state: RootState) => state.datapointExhibitionType.datapointExhibitionType);

  const isBlockedByPermission = isChecking || !isAllowed;
  const disabled = isDisabled || isLoading || isPendingEditedPrice || isBlockedByPermission;
  const isProduct = displayType === 'PRODUCT';
  const showsPermissionTooltip = !isChecking && !isAllowed;

  const requestApply = (applyToFamily: boolean) => {
    if (!isEffectiveDateEnabled) {
      handleApplyPrices(applyToFamily);
      return;
    }
    setPendingApplyToFamily(applyToFamily);
  };

  const handleConfirmEffectiveDate = (effectiveStartDate: string) => {
    handleApplyPrices(pendingApplyToFamily ?? false, effectiveStartDate);
    setPendingApplyToFamily(null);
  };

  const handleClick = () => requestApply(!isProduct);
  const handleSelect = (itemId: string) => {
    if (itemId === 'APPLY_TO_FAMILY') {
      requestApply(true);
    }
  };

  const effectiveDateModal = (
    <EffectiveDateModal
      show={pendingApplyToFamily !== null}
      selectedCount={selectedCount}
      onClose={() => setPendingApplyToFamily(null)}
      onConfirm={handleConfirmEffectiveDate}
    />
  );

  const buttonLabel = isPendingEditedPrice ? <Loader size="sm" className="mr-2" /> : 'Aplicar preço';

  const applyButton = isProduct ? (
    <ButtonDropdown
      id={CTA_BUTTON_ID}
      disabled={disabled}
      isLoading={isLoading}
      onClick={handleClick}
      onSelectOption={handleSelect}
      skin="blue"
      options={[
        {
          id: 'APPLY_TO_FAMILY',
          label: 'Aplicar na Família',
          value: 'APPLY_TO_FAMILY',
          disabled: isDisabledOption || isLoading || isPendingEditedPrice || isBlockedByPermission,
          placeholder,
        },
      ]}
    >
      {buttonLabel}
    </ButtonDropdown>
  ) : (
    <ButtonPrimary id={CTA_BUTTON_ID} disabled={disabled} isLoading={isLoading} onClick={handleClick}>
      {buttonLabel}
    </ButtonPrimary>
  );

  return (
    <>
      {showsPermissionTooltip ? <ApplyPermissionTooltip>{applyButton}</ApplyPermissionTooltip> : applyButton}
      {effectiveDateModal}
    </>
  );
};

export default memo(AppyPricesButton);
